import { ColorKeys } from '@common/types/theme';

const palette: Record<ColorKeys, string> = {
    // Primary
    'primary-50': 'b8d2Ed',
    'primary-100': 'EBF4FF',
    'primary-200': 'B0D5FF',
    'primary-300': '75B6FF',
    'primary-400': '3B98FF',
    'primary-500': '0C70D4',
    'primary-600': '005FBE',
    'primary-700': '004899',
    'primary-800': '042F60',
    'primary-900': '05162C',

    // Secondary
    'secondary-50': 'fa8700',
    'secondary-100': 'feddb8',
    'secondary-200': 'fcc17a',
    'secondary-300': 'fcad52',
    'secondary-400': 'fb9a29',
    'secondary-500': 'fa8700',
    'secondary-600': 'd27100',
    'secondary-700': 'aa5c00',
    'secondary-800': '824600',
    'secondary-900': '5a3100',

    // Secondary New
    // TODO This is temporary naming until we can refactor the current secondary color
    'secondaryNew-100': 'FAF9F5',
    'secondaryNew-150': 'F7F6F3',
    'secondaryNew-200': 'F0EFEB',
    'secondaryNew-300': 'DEDBCC',
    'secondaryNew-400': 'C8C5B6',

    // Neutral
    'neutral-100': 'f8f9fa',
    'neutral-300': 'E1E2E3',
    'neutral-450': 'ced4da',
    'neutral-500': 'B1B5B9',
    'neutral-550': '9A9EA0',
    'neutral-600': '707579',
    'neutral-650': 'f0f0f0',
    'neutral-700': '4D5053',
    'neutral-750': 'e0e0e0',
    'neutral-800': '373A3D',
    'neutral-900': '232527',

    // Confirm
    'confirm-50': 'bdeee2',
    'confirm-100': 'aae9d9',
    'confirm-200': '84dfc8',
    'confirm-300': '5fd6b8',
    'confirm-400': '39cca7',
    'confirm-500': '13c296',
    'confirm-600': '10a37e',
    'confirm-700': '0d8466',
    'confirm-800': '0a654e',
    'confirm-900': '074636',

    // Warning
    'warning-50': 'ffeeba',
    'warning-100': 'ffe9a6',
    'warning-200': 'ffdf7e',
    'warning-300': 'ffd556',
    'warning-400': 'ffcb2f',
    'warning-500': 'ffc107',
    'warning-600': 'd6a206',
    'warning-700': 'ad8305',
    'warning-800': '856404',
    'warning-900': '5c4503',

    // Error
    'error-50': 'f1caca',
    'error-100': 'edbbba',
    'error-200': 'e59c9c',
    'error-300': 'dd7e7d',
    'error-400': 'd55f5f',
    'error-500': 'cd4140',
    'error-600': 'ac3736',
    'error-700': '8b2c2c',
    'error-800': '6b2221',
    'error-900': '4a1717',

    //Gray
    'gray-50': '',
    'gray-100': '',
    'gray-200': '',
    'gray-300': '',
    'gray-400': '',
    'gray-500': '',
    'gray-600': '535862',
    'gray-700': '',
    'gray-800': '',
    'gray-900': '',
};

export { palette };
